import { type FC } from "react";

import type { NotificationFilter, NotificationInboxItem } from "@recobra/schemas/notification";
import { Skeleton } from "@recobra/ui/skeleton";

import { NotificationEmptyState } from "./NotificationEmptyState";
import { NotificationListItem } from "./NotificationListItem";
import type { NotificationNavigationTarget } from "./resolveNotificationNavigation";

export const NotificationList: FC<{
  items: NotificationInboxItem[];
  filter: NotificationFilter;
  isLoading: boolean;
  onMarkRead?: (id: string) => void;
  onNavigate?: (target: NotificationNavigationTarget, id: string) => void;
}> = ({ items, filter, isLoading, onMarkRead, onNavigate }) => {
  if (isLoading) {
    return (
      <div className="divide-y">
        {Array.from({ length: 5 }, (_, index) => (
          <div key={index} className="px-4 py-3">
            <Skeleton className="h-14 w-full" />
          </div>
        ))}
      </div>
    );
  }

  if (items.length === 0) {
    return <NotificationEmptyState filter={filter} />;
  }

  return (
    <div className="divide-y">
      {items.map((item) => (
        <NotificationListItem
          key={item.id}
          item={item}
          onMarkRead={onMarkRead}
          onNavigate={onNavigate}
        />
      ))}
    </div>
  );
};
